import {
  prefetchInfiniteWikiArticles,
  prefetchPage,
  prefetchTranslation,
} from '@Navigation/prefetchers';

import type { LoaderFn } from '@Types/Router';

export const loader: LoaderFn = (query) => async (args) => {
  const { queryClient } = query;
  const { request, params } = args;

  return Promise.all([
    prefetchInfiniteWikiArticles({ tagId: params.tagId }, queryClient),
    prefetchPage(request.url, queryClient),
    prefetchTranslation(request.url, queryClient),
  ]);
};
